export interface ReadReceipt {
  messageId: number;
  conversationId: number;
  applicationCode?: string;
  userId?: string;
}
